import React, { useEffect, useState } from 'react';
import { getBranchOwner } from '@config';
import { NfseProvider } from './context';
import NFPaulistanaPattern from './patterns';
import Loading from '../../../../_components/Loading';

export default function EmitNfse() {
  const branch = getBranchOwner();
  const [initializing, setInitializing] = useState(true);

  useEffect(() => {
    const currentBranch = getBranchOwner();
    if (!currentBranch) return;
    
    // Se não tem permissão 3 no banco, redireciona para tela de boas-vindas
    const hasPermission = currentBranch.permissions && currentBranch.permissions.nfse === 3;
    
    if (!hasPermission) {
      window.location.href = '/nfse/enable';
    } else {
      setInitializing(false);
    }
  }, []);

  if (initializing) {
    return <Loading />;
  }

  return (
    <div className="pb-3">
      <div className="">
        <NfseProvider>
          <NFPaulistanaPattern />
        </NfseProvider>
      </div>
    </div>
  );
}




// WEBPACK FOOTER //
// ./src/views/Fiscal/NFSe/emit/index.jsx